var React = require('react');

function ArrowLeft2 (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_188_602)","key":0},[React.createElement("path",{"d":"M16.0247 11.2176L6.59843 11.405","stroke":"#0577AF","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M11.4053 16.0244L6.59843 11.405L11.2178 6.59819","stroke":"#0577AF","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_188_602"},React.createElement("rect",{"width":"16","height":"16","fill":"white","transform":"translate(11.5361 22.623) rotate(-136.139)"})))]);
}

ArrowLeft2.defaultProps = {"width":"23","height":"23","viewBox":"0 0 23 23","fill":"none"};

module.exports = ArrowLeft2;

ArrowLeft2.default = ArrowLeft2;
